import { Box, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import sortBy from "lodash/sortBy";
import uniqBy from "lodash/uniqBy";
import type { FC } from "react";
import type { MarkerColor } from "../../misc/markerColors";
import { accountManagerColor, NO_ACCOUNT_MANAGER_COLOR } from "./accountManagerColor";
import type { LocatedCustomer } from "./locatedCustomer";

interface LegendEntry {
  readonly key: string;
  readonly label: string;
  readonly color: MarkerColor;
}

interface Props {
  readonly customers: LocatedCustomer[];
}

const CustomerMapLegend: FC<Props> = ({ customers }) => {
  const entries = legendEntries(customers);
  if (entries.length === 0) {
    return null;
  }
  return (
    <List dense disablePadding data-testid="customer-map-legend">
      {entries.map((entry) => (
        <ListItem key={entry.key} disableGutters>
          <ListItemIcon sx={{ minWidth: 28 }}>
            <Box sx={{ width: 16, height: 16, borderRadius: "4px", backgroundColor: entry.color.backgroundColor }} />
          </ListItemIcon>
          <ListItemText primary={entry.label} />
        </ListItem>
      ))}
    </List>
  );
};

function legendEntries(customers: LocatedCustomer[]): LegendEntry[] {
  const accountManagers = sortBy(
    uniqBy(
      customers.flatMap((customer) => (customer.accountManager ? [customer.accountManager] : [])),
      (accountManager) => accountManager.id,
    ),
    (accountManager) => accountManager.name,
  );
  const withoutAccountManager: LegendEntry[] = customers.some((customer) => !customer.accountManager)
    ? [{ key: "none", label: "Brak opiekuna", color: NO_ACCOUNT_MANAGER_COLOR }]
    : [];
  return [
    ...accountManagers.map((accountManager) => ({
      key: accountManager.id,
      label: accountManager.name,
      color: accountManagerColor(accountManager),
    })),
    ...withoutAccountManager,
  ];
}

export default CustomerMapLegend;
